export enum ContentIntentType {
  WELCOME = "WELCOME",
  MARKET_UPDATE = "MARKET_UPDATE",
  HOME_VALUE = "HOME_VALUE",
  CASH_OFFER = "CASH_OFFER",
  MORTGAGE = "MORTGAGE"
}
